var CalendarMonth = (function () {
    function CalendarMonth() {
    }
    return CalendarMonth;
}());
export { CalendarMonth };
var CalendarOptions = (function () {
    function CalendarOptions() {
    }
    return CalendarOptions;
}());
export { CalendarOptions };
var CalendarResult = (function () {
    function CalendarResult() {
    }
    return CalendarResult;
}());
export { CalendarResult };
//# sourceMappingURL=calendar.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-calendar/dist/calendar.model.js
// module id = 816
// module chunks = 73